import { NgModule } from "@angular/core";
import { ComponentsModule } from "./components/components.module";
import { DirectivesModule } from "./directives/directives.module";
import { PipesModule } from "./pipes/pipes.module";

@NgModule({
  imports: [ComponentsModule, DirectivesModule, PipesModule],
  exports: [ComponentsModule, DirectivesModule, PipesModule],
})
export class SharedModule {}
